export default __webpack_public_path__ + "static/media/client-17.4831bfa8.png";